import "./ProfessionalBlog.module.css";
import TopNavigation from "@/reusable_sections/Header";
import AiRevolutionHero from "./sections/AiRevolutionHero";
import LatestVideoGuidesAndArticles from "./sections/LatestVideoGuidesAndArticles";
import LetsStartWorkingOnYourBrand from "./sections/LetsStartWorkingOnYourBrand";
import InformationAndRights from "@/reusable_sections/Footer";
export default function ProfessionalBlogPage() {
  return <div>
      <TopNavigation />
      <AiRevolutionHero />
      <LatestVideoGuidesAndArticles />
      <LetsStartWorkingOnYourBrand />
      <InformationAndRights />
    </div>;
}